export var EMPTY_ARRAY = Object.freeze([]);
export var EMPTY_MAP = new Map();
export var EMPTY_FUNCTION = () => undefined;
/**
 * Wrap a value in an array if it is not already an array. Otherwise return the
 * value.
 * @param value The value to ensure is an array
 * @returns The value as an array
 */
export function ensureArray(value) {
  return Array.isArray(value) ? value : [value];
}

/**
 * Filters out any null or undefined values from an array.
 * @param maybeDefined
 */
export function removeNullAndUndefined() {
  for (var _len = arguments.length, maybeDefined = new Array(_len), _key = 0; _key < _len; _key++) {
    maybeDefined[_key] = arguments[_key];
  }
  return maybeDefined.filter(m => m != null);
}
//# sourceMappingURL=DataUtils.js.map